<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="contact-form col-lg-6">

              <form id="contact" action="#" method="post" @submit="checkForm">

                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                  </ul>
                </div>

                <div v-if="serverMessage" class="alert alert-success">
                  {{ serverMessage }}
                </div>

                <div class="d-flex">
                  <input type="text" pattern="\d*" @keyup="otpInput($event, 1)" v-model="otp.one" class="form-control otp-input otp_1" name="field-name" maxlength="1">
                  <input type="text" pattern="\d*" @keyup="otpInput($event, 2)" v-model="otp.two" class="form-control otp-input otp_2" name="field-name" maxlength="1">
                  <input type="text" pattern="\d*" @keyup="otpInput($event, 3)" v-model="otp.three" class="form-control otp-input otp_3" name="field-name" maxlength="1">
                  <input type="text" pattern="\d*" @keyup="otpInput($event, 4)" v-model="otp.four" class="form-control otp-input otp_4" name="field-name" maxlength="1">
                </div>

                <button type="submit" class="btn btn-primary mt-3 submit-btn">
                  পরবর্তী ধাপে যান <i class="fa fa-chevron-right"></i>
                </button>

                <div class="mt-2">
                  <router-link :to="{ name: 'login' }">লগইন করুন</router-link>
                </div>
                <div>
                  <router-link :to="{ name: 'signup' }">অ্যাকাউন্ট নেই? এখনই সাইন আপ করুন!</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import $ from "jquery";

export default {
  name: `login`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
      serverMessage: false,
      otp: {}
    };
  },
  methods: {
    otpInput(evt, sl) {
      const nextOtp = +sl + 1;
      if (evt.target.value.trim()) $(".otp_" + nextOtp).focus();
      if (nextOtp > 4) $(".submit-btn").focus();
    },
    async checkForm(e) {
      e.preventDefault();
      const otpNumber = this.otp.one + this.otp.two + this.otp.three + this.otp.four
      if (otpNumber.length != 4) {
        this.serverMessage = 'Please enter OTP correctly';
      }

      const formData = new FormData();
      formData.append(`phone`, localStorage.getItem('forgotMobile'));
      formData.append(`otp`, otpNumber);
      const response = await fetch(`${this.APIURL}customer/forgot-password/verify-otp`, {
        method: `POST`,
        body: formData,
      });
      const verifyOtpResponse = await response.json();
      localStorage.setItem('otpNumber', otpNumber);
      if (verifyOtpResponse.status) this.$router.push('reset-password');
      this.serverMessage = verifyOtpResponse.message;
    },
  },
};
</script>
